module.exports = __webpack_public_path__ + "img/image_middle_condition2_d_gif_1.5cb2df48.png";